import { jsx as _jsx } from "react/jsx-runtime";
import { createContext } from 'react';
const ViewContainerContext = /*#__PURE__*/createContext({});
export function withViewContainerContext(InnerComponent) {
  return props => {
    return /*#__PURE__*/_jsx(ViewContainerContext.Consumer, {
      children: context => /*#__PURE__*/_jsx(InnerComponent, Object.assign({}, props, {
        context: context
      }))
    });
  };
}
export default ViewContainerContext;